import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { db } from '../lib/supabase'
import LoadingSpinner from '../components/LoadingSpinner'

export default function DescuentoDetalle() {
  const { id } = useParams()
  const [descuento, setDescuento] = useState(null)

  useEffect(() => {
    const load = async () => {
      const { data } = await db.getDescuentoById(id)
      setDescuento(data || null)
    }
    load()
  }, [id])

  if (!descuento) {
    return (
      <main>
        <div className="container" style={{ maxWidth: 'var(--container-max-width)', margin: '0 auto', padding: '0 2rem' }}>
          <LoadingSpinner message="" size={64} />
        </div>
      </main>
    )
  }

  return (
    <>
      <Helmet>
        <title>{descuento.meta_title || descuento.titulo}</title>
        <meta name="description" content={descuento.meta_description || 'Descuento vigente en Plaza Aurora'} />
        <link rel="canonical" href={descuento.canonical_url || `${import.meta.env.VITE_SITE_URL || 'https://plazaaurora.pe'}/descuentos/${descuento.id}`} />
        <meta name="robots" content={descuento.robots_index === false ? 'noindex,nofollow' : 'index,follow'} />
        <meta property="og:title" content={descuento.meta_title || descuento.titulo} />
        <meta property="og:description" content={descuento.meta_description || 'Descuento vigente en Plaza Aurora'} />
        {descuento.og_image_url && <meta property="og:image" content={descuento.og_image_url} />}
      </Helmet>

      {descuento.json_ld && (
        <script type="application/ld+json">{descuento.json_ld}</script>
      )}

      <main>
        <div className="container" style={{ maxWidth: 'var(--container-max-width)', margin: '0 auto', padding: '0 2rem' }}>
          <section style={{ marginTop: '1.5rem', marginBottom: '4rem' }}>
            {descuento.imagen_url && (
              <img src={descuento.imagen_url} alt={descuento.imagen_alt || descuento.titulo} style={{
                width: '100%',
                height: '320px',
                objectFit: 'cover',
                borderRadius: 'var(--radius-md)'
              }} />
            )}

            <h1 style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 'var(--font-weight-bold)',
              color: 'var(--color-text-primary)',
              margin: '1rem 0'
            }}>{descuento.titulo}</h1>

            <p style={{ color: 'var(--color-text-muted)' }}>
              Vigencia: {descuento.fecha_inicio} {descuento.fecha_fin ? `— ${descuento.fecha_fin}` : ''}
            </p>

            {descuento.descripcion && (
              <p style={{
                fontFamily: 'var(--font-ui)',
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-primary)',
                lineHeight: 'var(--line-height-relaxed)',
                whiteSpace: 'pre-line',
                marginTop: '1rem'
              }}>{descuento.descripcion}</p>
            )}

            {/* Attached brands */}
            {Array.isArray(descuento.descuentos_marcas) && descuento.descuentos_marcas.length > 0 && (
              <div style={{ marginTop: '2rem' }}>
                <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--font-size-h2)' }}>Marcas participantes</h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: '1rem', marginTop: '1rem' }}>
                  {descuento.descuentos_marcas.map((m) => (<div key={m.id} style={{ background: 'white', borderRadius: 'var(--radius-md)', padding: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid var(--color-stroke)' }}>{m.tienda_id && m.tiendas ? (m.tiendas.logo_url ? <img src={m.tiendas.logo_url} alt={m.tiendas.nombre} style={{ maxHeight: '64px', objectFit: 'contain', maxWidth: '100%' }} /> : <span style={{ fontFamily: 'var(--font-ui)', fontSize: 'var(--font-size-small)', fontWeight: 'var(--font-weight-medium)', color: 'var(--color-text-primary)', textAlign: 'center' }}>{m.tiendas.nombre}</span>) : (m.brand_logo_url ? <img src={m.brand_logo_url} alt={m.brand_name || 'Marca'} style={{ maxHeight: '64px', objectFit: 'contain', maxWidth: '100%' }} /> : <span style={{ fontFamily: 'var(--font-ui)', fontSize: 'var(--font-size-small)', fontWeight: 'var(--font-weight-medium)', color: 'var(--color-text-primary)', textAlign: 'center' }}>{m.brand_name}</span>)}</div>))}
                </div>
              </div>
            )}
          </section>
        </div>
      </main>
    </>
  )
}

